var map = {
	"./404.vue": 6,
	"./Bio.vue": 25,
	"./Home.vue": 26,
	"./Resume.vue": 27
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9;


//////////////////
// WEBPACK FOOTER
// ./src/pages ^\.\/.*\.vue$
// module id = 9
// module chunks = 0